import React, { useCallback, useState } from "react";
import { DashboardPeopleSelectionContext } from "./DashboardPeopleSelectionContext";

/** Key this provider by the signed-in user and workspace to isolate saved preferences. */
export default function DashboardPeopleSelectionProvider({
  storageKey,
  children,
}: {
  storageKey: string;
  children: React.ReactNode;
}) {
  const [selection, setSelection] = useState(() => {
    try {
      return localStorage.getItem(storageKey) ?? "all";
    } catch {
      return "all";
    }
  });
  const remember = useCallback(
    (next: string) => {
      setSelection(next);
      try {
        localStorage.setItem(storageKey, next);
      } catch {
        // Keep the in-memory selection when browser storage is unavailable.
      }
    },
    [storageKey],
  );
  return (
    <DashboardPeopleSelectionContext.Provider value={{ selection, remember }}>
      {children}
    </DashboardPeopleSelectionContext.Provider>
  );
}
